import { DesignData } from '../types';

import getPageCountStep from './getPageCountStep';
import { getGridStepInPages } from './getSpreadCountForIncrement';
import { PageCountLimit } from './pageCountControls';

// The page rules a host gets until it sends `enablePageCountOptions`: one even grid step per click,
// gated on min and max alone. Kept apart so turning the setting off changes nothing, and removed
// with it.

export function legacyGetSpreadCountForIncrement(
  designData: DesignData,
  spreadIndex: number,
  validPageCounts?: number[],
): number {
  const stepInPages =
    validPageCounts && validPageCounts.length > 1
      ? getGridStepInPages(validPageCounts)
      : designData.page_count_limit?.increment ?? 0;
  if (!stepInPages) {
    return 1;
  }

  const pagesPerSpread = designData.spreads[spreadIndex]?.pages.length || 1;
  return Math.max(1, Math.round(stepInPages / pagesPerSpread));
}

export function legacyCanAddPagesForSpread(
  designData: DesignData | undefined,
  canAddAfter: boolean,
  pageCountLimit: PageCountLimit | undefined,
): boolean {
  if (!pageCountLimit || !canAddAfter) {
    return false;
  }
  const step = getPageCountStep(designData, pageCountLimit.increment);
  const pageCount = designData?.page_count ?? 0;
  return pageCount + step <= pageCountLimit.max;
}

export function legacyCanRemovePagesForSpread(
  designData: DesignData | undefined,
  canRemove: boolean,
  pageCountLimit: PageCountLimit | undefined,
): boolean {
  if (!pageCountLimit || !canRemove) {
    return false;
  }
  const step = getPageCountStep(designData, pageCountLimit.increment);
  const pageCount = designData?.page_count ?? 0;
  return pageCount - step >= pageCountLimit.min;
}

export function legacyIsAtMinPageCount(
  designData: DesignData | undefined,
  pageCountLimit: PageCountLimit | undefined,
): boolean {
  if (!pageCountLimit) {
    return false;
  }
  const step = getPageCountStep(designData, pageCountLimit.increment);
  const pageCount = designData?.page_count ?? 0;
  return pageCount - step < pageCountLimit.min;
}
